// src/utils/operatorUtils.js

/**
 * Calculates SHA-256 hash of a PIN with a salt.
 * @param {string} pin - 4 digit PIN
 * @returns {Promise<string>} Hex representation of the hash
 */
export async function hashPin(pin) {
  const salt = "semprejoias_oficina_salt_2026";
  const encoder = new TextEncoder();
  const data = encoder.encode(pin + salt);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Gets active operator from localStorage.
 * @param {string} type - 'OFICINA' or 'PDV'
 * @returns {object|null}
 */
export function getActiveOperator(type = "OFICINA") {
  try {
    const key = `oficina_active_operator_${String(type).toLowerCase()}`;
    const data = localStorage.getItem(key);
    if (!data) return null;
    return JSON.parse(data);
  } catch (e) {
    console.error(`Erro ao obter operador ativo para ${type}:`, e);
    return null;
  }
}

/**
 * Saves active operator to localStorage.
 * @param {object} operator
 * @param {string} type - 'OFICINA' or 'PDV'
 */
export function setActiveOperator(operator, type = "OFICINA") {
  try {
    if (!operator) {
      clearActiveOperator(type);
      return;
    }
    const key = `oficina_active_operator_${String(type).toLowerCase()}`;
    localStorage.setItem(key, JSON.stringify(operator));
  } catch (e) {
    console.error(`Erro ao salvar operador ativo para ${type}:`, e);
  }
}

/**
 * Clears active operator from localStorage.
 * @param {string} type - 'OFICINA' or 'PDV'
 */
export function clearActiveOperator(type = "OFICINA") {
  try {
    const key = `oficina_active_operator_${String(type).toLowerCase()}`;
    localStorage.removeItem(key);
  } catch (e) {
    console.error(`Erro ao limpar operador ativo para ${type}:`, e);
  }
}
